import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-cdfc5f32"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "foot-box" };
export default /*#__PURE__*/ _defineComponent({
    name: 'Foot',
    setup(__props) {
        const year = new Date().getFullYear();
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, "Copyright@" + _toDisplayString(_unref(year)) + " 京ICP备2023002581号", 1));
        };
    }
});
